import { template as template_ec112d0b0471438cbab3b9ea01f5c2c6 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { isPresent } from '@ember/utils';
import { service } from '@ember/service';
import StandardModal from 'eflex/components/standard-modal';
import EmberGrid from 'eflex/components/ember-grid';
import { t } from 'ember-intl';
import { formatDate } from 'eflex/helpers';
export default class ConfigurationHistoryAcknowledgeModal extends Component {
    @service
    systemConfig;
    get showConfigurationNotificationModal() {
        return this.systemConfig.jem?.configurationHistory && !this.args.stationIsRunning && isPresent(this.args.configurationHistories);
    }
    getDisplayUserName = (userFragment)=>{
        if (!userFragment) {
            return null;
        }
        const fullName = `${userFragment.firstName ?? ''} ${userFragment.lastName ?? ''}`;
        if (fullName.trim().length > 0) {
            return fullName;
        } else {
            return userFragment.userName;
        }
    };
    static{
        template_ec112d0b0471438cbab3b9ea01f5c2c6(`
    {{#if this.showConfigurationNotificationModal}}
      <StandardModal
        class="configuration-history-acknowledge-modal"
        @size="lg"
        @keyboard="false"
        @onConfirm={{@onConfirm}}
        ...attributes
      as |modal|>
        <modal.header>
          {{t "jem.acknowledgeConfigurationHistories"}}
        </modal.header>
        <modal.body>
          <div class="row mb-1">
            {{#if @totalConfigurationHistories}}
              <div class="col text-end total-logs">
                {{t "jem.totalConfigurationHistoriesToAcknowledge" total=@totalConfigurationHistories}}
              </div>
            {{/if}}
          </div>
          <div class="row logs-grid-wrapper h-100">
            <div class="col-md-12 h-100">
              <EmberGrid
                @hideLoadMore={{true}}
                @data={{@configurationHistories}}
                @fetch={{@fetch}}
              >
                <thead>
                  <tr>
                    <th>
                      {{t "date"}}
                    </th>
                    <th>
                      {{t "user"}}
                    </th>
                    <th>
                      {{t "type"}}
                    </th>
                    <th>
                      {{t "logs.message"}}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {{#each @configurationHistories as |config|}}
                    <tr class="configuration-history-row">
                      <td class="configuration-history-timestamp">
                        {{formatDate config.timestamp}}
                      </td>
                      <td class="configuration-history-createdby">
                        {{this.getDisplayUserName config.user}}
                      </td>
                      <td>
                        {{config.type}}
                      </td>
                      <td class="configuration-history-message">
                        {{config.note}}
                      </td>
                    </tr>
                  {{/each}}
                </tbody>
              </EmberGrid>
            </div>
          </div>

        </modal.body>
        <modal.footer as |footer|>
          <footer.confirm>
            {{t "acknowledgeAll"}}
          </footer.confirm>
        </modal.footer>
      </StandardModal>
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
